export const LINKS_CONFIG = {
  dev: {
    icyte_analytics: "https://dev-icyte-analytics.integrichain.net/#",
    icyte_gtn: "https://dev-gtn-shared-v2.integrichain.net/validatessouser",
    icyte_payment: "https://dev-login.integrichain.net/?callback_url=https://dev-payportal-v2.integrichain.net/api/authorize/cognito",
    icyte_dcm: "https://dev-icyte-channel-apps.integrichain.net/DNAPORTAL/?sc",
    icyte_om: "https://dev-icyte-channel-apps.integrichain.net/DNAPORTAL/?om",
    share_file: "https://integrichain.sharefile.com/",
    contracts_and_pricing: 'https://dev-icyte-sparc.integrichain.net/api/auth-v2/authorize/cognito',
    contracts_and_pricing_analytics: '#',
  },
  test: {
    icyte_analytics: "https://test-icyte-analytics.integrichain.net/",
    icyte_gtn: "https://test-gtn-shared-v2.integrichain.net/validatessouser",
    icyte_payment: "https://test-login.integrichain.net/?callback_url=https://qa-payportal-v2.integrichain.net/api/authorize/cognito",
    icyte_dcm: "https://test-icyte-channel-apps.integrichain.net/DNAPORTAL/?sc",
    icyte_om: "https://test-icyte-channel-apps.integrichain.net/DNAPORTAL/?om",
    share_file: "https://integrichain.sharefile.com/",
    contracts_and_pricing: 'https://qa-icyte-sparc.integrichain.net/api/auth-v2/authorize/cognito',
    contracts_and_pricing_analytics: 'https://uat-sisense.integrichain.com/',
  },
  test_2: {
    icyte_analytics: "https://test-icyte-analytics.integrichain.net/",
    icyte_gtn: "https://test-gtn-shared-v2.integrichain.net/validatessouser",
    icyte_payment: "https://test-login.integrichain.net/?callback_url=https://qa2-payportal-v2.integrichain.net/api/authorize/cognito",
    icyte_dcm: "https://test-icyte-channel-apps.integrichain.net/DNAPORTAL/?sc",
    icyte_om: "https://test-icyte-channel-apps.integrichain.net/DNAPORTAL/?om",
    share_file: "https://integrichain.sharefile.com/",
    contracts_and_pricing: 'https://qa-icyte-sparc.integrichain.net/api/auth-v2/authorize/cognito',
    contracts_and_pricing_analytics: 'https://uat-sisense.integrichain.com/',
  },
  test_3: {
    icyte_analytics: "https://test-icyte-analytics.integrichain.net/",
    icyte_gtn: "https://test-gtn-shared-v2.integrichain.net/validatessouser",
    icyte_payment: "https://test-login.integrichain.net/?callback_url=https://qa3-payportal-v2.integrichain.net/api/authorize/cognito",
    icyte_dcm: "https://test-icyte-channel-apps.integrichain.net/DNAPORTAL/?sc",
    icyte_om: "https://test-icyte-channel-apps.integrichain.net/DNAPORTAL/?om",
    share_file: "https://integrichain.sharefile.com/",
    contracts_and_pricing: 'https://qa-icyte-sparc.integrichain.net/api/auth-v2/authorize/cognito',
    contracts_and_pricing_analytics: 'https://uat-sisense.integrichain.com/',
  },
  test_snowflake: {
    icyte_analytics: "https://test-dod-ui-data-cloud.integrichain.net/",
    icyte_gtn: "https://test-gtn-shared-v2.integrichain.net/validatessouser",
    icyte_payment: "https://qa-payportal-v2.integrichain.net/login",
    icyte_dcm: "https://test-icyte-portal-data-cloud.integrichain.net/DNAPORTAL/?sc",
    icyte_om: "https://test-icyte-portal-data-cloud.integrichain.net/DNAPORTAL/?om",
    share_file: "https://integrichain.sharefile.com/",
    contracts_and_pricing: 'https://qa-icyte-sparc.integrichain.net/api/auth-v2/authorize/cognito',
    contracts_and_pricing_analytics: 'https://uat-sisense.integrichain.com/',
  },
  uat: {
    icyte_analytics: "https://uat-icyte-analytics.integrichain.com/",
    icyte_gtn: "https://uat2-gtn-shared-v2.integrichain.com/validatessouser",
    icyte_payment: "https://uat-login.integrichain.com/?callback_url=https://uat-payportal-v2.integrichain.com/api/authorize/cognito",
    icyte_dcm: "https://uat-icyte-channel-apps.integrichain.com/DNAPORTAL/?sc",
    icyte_om: "https://uat-icyte-channel-apps.integrichain.com/DNAPORTAL/?om",
    share_file: "https://integrichain.sharefile.com/",
    contracts_and_pricing: 'https://uat-icyte-apps.integrichain.com/api/auth-v2/authorize/cognito',
    contracts_and_pricing_analytics: 'https://uat-sisense.integrichain.com/',
  },
  uat_snowflake: {
    icyte_analytics: "https://uat-dod-ui-data-cloud.integrichain.com/",
    icyte_gtn: "https://uat2-gtn-shared-v2.integrichain.com/validatessouser",
    icyte_payment: "https://uat2-payportal-v2.integrichain.com/login",
    icyte_dcm: "https://uat-icyte-portal-data-cloud.integrichain.com/DNAPORTAL/?sc",
    icyte_om: "https://uat-icyte-portal-data-cloud.integrichain.com/DNAPORTAL/?om",
    share_file: "https://integrichain.sharefile.com/",
    contracts_and_pricing: 'https://uat-icyte-apps.integrichain.com/api/auth-v2/authorize/cognito',
    contracts_and_pricing_analytics: 'https://uat-sisense.integrichain.com/',
  },
  prod: {
    icyte_analytics: "https://icyte-analytics.integrichain.com/",
    icyte_gtn: "https://prod-gtn-shared-v2.integrichain.com/validatessouser",
    icyte_payment: "https://login.integrichain.com/?callback_url=https://payportal-v2.integrichain.com/api/authorize/cognito",
    icyte_dcm: "https://icyte-channel-apps.integrichain.com/DNAPORTAL/?sc",
    icyte_om: "https://icyte-channel-apps.integrichain.com/DNAPORTAL/?om",
    share_file: "https://integrichain.sharefile.com/",
    contracts_and_pricing: 'https://icyte-apps.integrichain.com/api/auth-v2/authorize/cognito',
    contracts_and_pricing_analytics: 'https://icyte-sisense.integrichain.com/',
  },
  prod_snowflake: {
    icyte_analytics: "https://prod-dod-ui-data-cloud.integrichain.com/",
    icyte_gtn: "https://prod-gtn-shared-v2.integrichain.com/validatessouser",
    icyte_payment: "https://payportal-v2.integrichain.com/login",
    icyte_dcm: "https://prod-icyte-portal-data-cloud.integrichain.com/DNAPORTAL/?sc",
    icyte_om: "https://prod-icyte-portal-data-cloud.integrichain.com/DNAPORTAL/?om",
    share_file: "https://integrichain.sharefile.com/",
    contracts_and_pricing: 'https://icyte-apps.integrichain.com/api/auth-v2/authorize/cognito',
    contracts_and_pricing_analytics: 'https://icyte-sisense.integrichain.com/',
  },
  lilly_dev: {
    icyte_analytics: "https://uat-icyte-analytics.integrichain.com/",
    icyte_gtn: "#",
    icyte_payment: "https://uat-login.integrichain.com/?callback_url=https://dev-lilly-payportal-v2.integrichain.com/api/authorize/cognito",
    icyte_dcm: "https://uat-icyte-channel-apps.integrichain.com/DNAPORTAL/?sc",
    icyte_om: "https://uat-icyte-channel-apps.integrichain.com/DNAPORTAL/?om",
    share_file: "https://integrichain.sharefile.com/",
    contracts_and_pricing: 'https://uat-lilly-icyte-apps.integrichain.com/ ',
    contracts_and_pricing_analytics: 'https://uat-lillysisense.integrichain.com/app/account/login',
  },
  lilly_uat: {
    icyte_analytics: "https://uat-icyte-analytics.integrichain.com/",
    icyte_gtn: "#",
    icyte_payment: "https://uat-login.integrichain.com/?callback_url=https://uat-lilly-payportal-v2.integrichain.com/api/authorize/cognito",
    icyte_dcm: "https://uat-icyte-channel-apps.integrichain.com/DNAPORTAL/?sc",
    icyte_om: "https://uat-icyte-channel-apps.integrichain.com/DNAPORTAL/?om",
    share_file: "https://integrichain.sharefile.com/",
    contracts_and_pricing: 'https://uat-lilly-icyte-apps.integrichain.com/ ',
    contracts_and_pricing_analytics: 'https://uat-lillysisense.integrichain.com/app/account/login',
  },
  lilly_uat2: {
    icyte_analytics: "https://uat-icyte-analytics.integrichain.com/",
    icyte_gtn: "#",
    icyte_payment: "https://uat-login.integrichain.com/?callback_url=https://uat2-lilly-payportal-v2.integrichain.com/api/authorize/cognito",
    icyte_dcm: "https://uat-icyte-channel-apps.integrichain.com/DNAPORTAL/?sc",
    icyte_om: "https://uat-icyte-channel-apps.integrichain.com/DNAPORTAL/?om",
    share_file: "https://integrichain.sharefile.com/",
    contracts_and_pricing: 'https://uat2-lilly-icyte-apps.integrichain.com/ ',
    contracts_and_pricing_analytics: 'https://uat-lillysisense.integrichain.com/app/account/login',
  },
  lilly_test: {
    icyte_analytics: "https://uat-icyte-analytics.integrichain.com/",
    icyte_gtn: "#",
    icyte_payment: "https://uat-login.integrichain.com/?callback_url=https://qa-lilly-payportal-v2.integrichain.com/api/authorize/cognito",
    icyte_dcm: "https://uat-icyte-channel-apps.integrichain.com/DNAPORTAL/?sc",
    icyte_om: "https://uat-icyte-channel-apps.integrichain.com/DNAPORTAL/?om",
    share_file: "https://integrichain.sharefile.com/",
    contracts_and_pricing: 'https://uat-lilly-icyte-apps.integrichain.com/ ',
    contracts_and_pricing_analytics: 'https://uat-lillysisense.integrichain.com/app/account/login',
  },
  lilly_prod: {
    icyte_analytics: "https://icyte-analytics.integrichain.com/",
    icyte_gtn: "#",
    icyte_payment: "https://login.integrichain.com/?callback_url=https://lilly-payportal-v2.integrichain.com/api/authorize/cognito",
    icyte_dcm: "https://uat-icyte-channel-apps.integrichain.com/DNAPORTAL/?sc",
    icyte_om: "https://uat-icyte-channel-apps.integrichain.com/DNAPORTAL/?om",
    share_file: "https://integrichain.sharefile.com/",
    contracts_and_pricing: 'https://lilly-icyte-apps.integrichain.com/',
    contracts_and_pricing_analytics: 'https://prod-lillysisense.integrichain.com/',
  }
}
